import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Observable } from 'rxjs';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class AmpliacaoService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  create(data: any, idContrato: string | null) {
    return this.http.post(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-ampliacao`, { ...data });
  }
  edit(data: any, idContrato: string | null, idServicoAmpliacao: string | null) {
    return this.http.put(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-ampliacao/${idServicoAmpliacao}`, data);
  }
  getServicosAmpliacao(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idContrato: string | null,
    statusFilter: any,
    filterData?: any | null,
    nomeTipoObra?: string | null,
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('codigo', filterData?.value?.codigo || '')
      .set('nomeTipoObra', nomeTipoObra || '')
      .set('kmInicial', filterData?.value?.kmInicial || '')
      .set('kmFinal', filterData?.value?.kmFinal || '')
      .set('valor', filterData?.value?.valor || '')
      .set('kmExtensao', filterData?.value?.kmExtensao || '')
    if (statusFilter && statusFilter != 'Todos') {
      statusFilter.forEach((status: any) => params = params.append('statusParametro', status.label))
    }
    if (filterData?.value?.prazoVigenteInicial) {
      params = params.append('prazoVigenteInicial', moment(filterData?.value?.prazoVigenteInicial).format('YYYY-MM-DD'))
    }
    if (filterData?.value?.prazoVigenteFinal) {
      params = params.append('prazoVigenteFinal', moment(filterData?.value?.prazoVigenteFinal).format('YYYY-MM-DD'))
    }

    return this.http.get(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-ampliacao`, { params });
  }
  getServicoAmpliacao(idContrato: any, idServicoAmpliacao: any) {
    return this.http.get(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-ampliacao/${idServicoAmpliacao}`);
  }

  getOrigensObra(page = 0, size = 50, nome?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size)
      .set('sortField', 'nome')
      .set('sortDirection', 'asc');
    if (nome) params = params.set('nome', nome);

    return this.http.get(`${this.baseUrl}/v1/origens-obra`, { params });
  }

  getTiposObra(page = 0, size = 50, nome?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size)
      .set('sortField', 'nome')
      .set('sortDirection', 'asc');
    if (nome) params = params.set('nome', nome);

    return this.http.get(`${this.baseUrl}/v1/tipos-obra`, { params });
  }

  getMunicipios(page = 0, size = 900, nome?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size)
      .set('sortField', 'nome')
      .set('sortDirection', 'asc')
      .set('uf', 'MG');
    if (nome) params = params.set('nome', nome);

    return this.http.get(`${this.baseUrl}/v1/municipios`, { params });
  }

  deleteServico(id: any, contractId: any) {
    return this.http.delete(this.baseUrl + `/v1/contratos/${contractId}/parametros-servicos-ampliacao/${id}`);
  }
  ativarServicos(contractId: any, id: any, data: any) {
    return this.http.patch(`${this.baseUrl}/v1/contratos/${contractId}/parametros-servicos-ampliacao/${id}/ativar`, { ...data })
  }
  cancelarServicos(contractId: any, id: any, data: any) {
    return this.http.patch(`${this.baseUrl}/v1/contratos/${contractId}/parametros-servicos-ampliacao/${id}/cancelar`, { ...data })
  }
  getHistorico(id: string | null, idContrato: any, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
      `/v1/contratos/${idContrato}/parametros-servicos-ampliacao/${id}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`
    );
  }
  validateImport(contractId: any, data: any) {
    const formData = new FormData();
    formData.append('objetoOriginal', data?.file);
    return this.http.post(`${this.baseUrl}/v1/contratos/${contractId}/parametros-servicos-ampliacao/validar-importacao`, formData)
  }

  import(contractId: any, data: any, file: any, cpnj: any) {
    const formData = new FormData();
    const registrosValidosBlob = new Blob(
      [JSON.stringify(data?.registrosValidos)],
      { type: 'application/json' }
    );
    formData.append('registrosValidos', registrosValidosBlob);
    formData.append('nomeArquivo', file?.name);
    const fileExtension = file.type.split('/')[1];
    formData.append('tipoMime', fileExtension);
    formData.append('categoria', 'cadastro_contrato');
    formData.append('subCategoria', cpnj);
    formData.append('objetoOriginal', file?.file);
    return this.http.post(`${this.baseUrl}/v1/contratos/${contractId}/parametros-servicos-ampliacao/importar`, formData)
  }
}
